import { render } from "./Preavvisi.vue?vue&type=template&id=5a3324e0&scoped=true"
import script from "./Preavvisi.vue?vue&type=script&lang=js"
export * from "./Preavvisi.vue?vue&type=script&lang=js"

import "./Preavvisi.vue?vue&type=style&index=0&id=5a3324e0&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3324e0"]])

export default __exports__